import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Set } from "immutable";
import * as React from "react";
import { WiseConfig } from "../../../Shared/features/WiseConfig";
import { errorText, getNavigation, loadingText } from "../../custom_api/api";
import { showCookiebarLink } from "./cookiebar/cookiebar";
import { LinkButton } from "./library/button";
import { Row } from "./library/container";
import { Link } from "./library/link";
import { trackNewsletter } from "./library/tracking";
export class Footer extends React.Component {
    componentWillMount() {
        getNavigation("footer").then((res)=>{
            if (res != "error" && res != "loading") {
                this.setState((s)=>({
                        ...s,
                        items: Set(res)
                    }));
            }
        });
        getNavigation("footer-secondary").then((res)=>{
            if (res != "error" && res != "loading") {
                this.setState((s)=>({
                        ...s,
                        secundaryItems: Set(res)
                    }));
            }
        });
    }
    render() {
        const p = this.props;
        const s = this.state;
        return /*#__PURE__*/ _jsxs("footer", {
            id: "a11y-footer",
            className: "footer",
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: "footer__top",
                    children: /*#__PURE__*/ _jsx("div", {
                        className: "footer__container container--mg align--center",
                        children: /*#__PURE__*/ _jsxs(Row, {
                            children: [
                                /*#__PURE__*/ _jsxs("div", {
                                    className: "col-xs-12 col-md-6",
                                    children: [
                                        /*#__PURE__*/ _jsx("h2", {
                                            className: "footer__title title--s",
                                            children: "Altijd op de hoogte"
                                        }),
                                        /*#__PURE__*/ _jsx("p", {
                                            className: "footer__text",
                                            children: "Wil je op de hoogte blijven van de laatste ontwikkelingen in de bibliotheek? Meld je dan aan voor onze nieuwsbrief."
                                        }),
                                        /*#__PURE__*/ _jsx(LinkButton, {
                                            variant: "white",
                                            route: `${WiseConfig().BaseUrl}/wise-apps/opac/branch/${WiseConfig().LibraryId}/subscription/newsletter`,
                                            handle: ()=>trackNewsletter(),
                                            children: "Aanmelden nieuwsbrief"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsx("div", {
                                    className: "col-xs-12 col-md-6",
                                    children: /*#__PURE__*/ _jsx("div", {
                                        className: "footer__social",
                                        children: /*#__PURE__*/ _jsxs("div", {
                                            className: "footer__inner",
                                            children: [
                                                /*#__PURE__*/ _jsx("h2", {
                                                    className: "footer__title title--s",
                                                    children: "Sociaal"
                                                }),
                                                /*#__PURE__*/ _jsx("p", {
                                                    className: "footer__text",
                                                    children: "Volg jij ons al?"
                                                }),
                                                /*#__PURE__*/ _jsxs("div", {
                                                    className: "footer__socials",
                                                    children: [
                                                        /*#__PURE__*/ _jsxs(Link, {
                                                            className: "button button--secondary button--icon",
                                                            url: "https://www.tiktok.com/@denieuwebibliotheek",
                                                            title: "Tiktok",
                                                            children: [
                                                                /*#__PURE__*/ _jsx("span", {
                                                                    className: "sr-text",
                                                                    id: "social-tiktok",
                                                                    children: "Ons Tiktok account"
                                                                }),
                                                                /*#__PURE__*/ _jsx("svg", {
                                                                    className: "button__icon social__icon",
                                                                    width: "24",
                                                                    height: "24",
                                                                    "aria-hidden": "true",
                                                                    children: /*#__PURE__*/ _jsx("use", {
                                                                        xlinkHref: "#icon--tiktok"
                                                                    })
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ _jsxs(Link, {
                                                            className: "button button--secondary button--icon",
                                                            url: "https://www.facebook.com/denieuwebibliotheek/",
                                                            title: "Facebook",
                                                            children: [
                                                                /*#__PURE__*/ _jsx("span", {
                                                                    className: "sr-text",
                                                                    children: "Ons Facebook account"
                                                                }),
                                                                /*#__PURE__*/ _jsx("svg", {
                                                                    className: "button__icon social__icon",
                                                                    width: "24",
                                                                    height: "24",
                                                                    "aria-hidden": "true",
                                                                    children: /*#__PURE__*/ _jsx("use", {
                                                                        xlinkHref: "#icon--facebook"
                                                                    })
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ _jsxs(Link, {
                                                            className: "button button--secondary button--icon",
                                                            url: "https://www.instagram.com/denieuwebibliotheek/",
                                                            title: "Instagram",
                                                            children: [
                                                                /*#__PURE__*/ _jsx("span", {
                                                                    className: "sr-text",
                                                                    children: "Ons Instagram account"
                                                                }),
                                                                /*#__PURE__*/ _jsx("svg", {
                                                                    className: "button__icon social__icon",
                                                                    width: "24",
                                                                    height: "24",
                                                                    "aria-hidden": "true",
                                                                    children: /*#__PURE__*/ _jsx("use", {
                                                                        xlinkHref: "#icon--instagram"
                                                                    })
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ _jsxs(Link, {
                                                            className: "button button--secondary button--icon",
                                                            url: "https://www.youtube.com/c/DenieuwebibliotheekAlmere",
                                                            title: "YouTube",
                                                            children: [
                                                                /*#__PURE__*/ _jsx("span", {
                                                                    className: "sr-text",
                                                                    children: "Ons YouTube account"
                                                                }),
                                                                /*#__PURE__*/ _jsx("svg", {
                                                                    className: "button__icon social__icon",
                                                                    width: "24",
                                                                    height: "24",
                                                                    "aria-hidden": "true",
                                                                    children: /*#__PURE__*/ _jsx("use", {
                                                                        xlinkHref: "#icon--youtube"
                                                                    })
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ _jsxs(Link, {
                                                            className: "button button--secondary button--icon",
                                                            url: "https://nl.linkedin.com/company/de-nieuwe-bibliotheek-almere",
                                                            title: "LinkedIn",
                                                            children: [
                                                                /*#__PURE__*/ _jsx("span", {
                                                                    className: "sr-text",
                                                                    children: "Ons LinkedIn account"
                                                                }),
                                                                /*#__PURE__*/ _jsx("svg", {
                                                                    className: "button__icon social__icon",
                                                                    width: "24",
                                                                    height: "24",
                                                                    "aria-hidden": "true",
                                                                    children: /*#__PURE__*/ _jsx("use", {
                                                                        xlinkHref: "#icon--linkedin"
                                                                    })
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    })
                                })
                            ]
                        })
                    })
                }),
                /*#__PURE__*/ _jsxs("div", {
                    className: "footer__bottom",
                    children: [
                        /*#__PURE__*/ _jsxs("div", {
                            className: "footer__section--primary",
                            children: [
                                " ",
                                s.items == "loading" ? loadingText : s.items == "error" ? errorText : /*#__PURE__*/ _jsx("nav", {
                                    className: "footer__links container--mg align--center",
                                    "aria-label": "Footer",
                                    children: /*#__PURE__*/ _jsx("ul", {
                                        className: "footer__links",
                                        children: s.items.map((link)=>/*#__PURE__*/ _jsx("li", {
                                                className: "footer__link",
                                                children: /*#__PURE__*/ _jsx(Link, {
                                                    url: link.external ? link.absolute : link.relative,
                                                    external: link.external,
                                                    className: "link link--secondary link--arrow",
                                                    children: link.title
                                                }, link.key)
                                            }, `li-${link.key}`))
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsxs("div", {
                            className: "footer__section--secondary",
                            children: [
                                " ",
                                s.secundaryItems == "loading" ? loadingText : s.secundaryItems == "error" ? errorText : /*#__PURE__*/ _jsx("nav", {
                                    className: "footer__links container--mg align--center text--xs",
                                    "aria-label": "Wettelijk",
                                    children: /*#__PURE__*/ _jsxs("ul", {
                                        className: "footer__links",
                                        children: [
                                            s.secundaryItems.map((link)=>/*#__PURE__*/ _jsx("li", {
                                                    className: "footer__link",
                                                    children: /*#__PURE__*/ _jsx(Link, {
                                                        url: link.external ? link.absolute : link.relative,
                                                        external: link.external,
                                                        children: link.title
                                                    }, link.key)
                                                }, `li-${link.key}`)),
                                            /*#__PURE__*/ _jsx("li", {
                                                className: "footer__link",
                                                children: showCookiebarLink({
                                                    showCookiebar: p.showCookiebar
                                                })
                                            }, `li-reset`)
                                        ]
                                    })
                                })
                            ]
                        })
                    ]
                })
            ]
        });
    }
    constructor(props){
        super(props);
        this.state = {
            items: "loading",
            secundaryItems: "loading"
        };
    }
}
{}